import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconHamburgerMenu(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M0 5.5A1.5 1.5 0 0 1 1.5 4h21a1.5 1.5 0 0 1 0 3h-21A1.5 1.5 0 0 1 0 5.5ZM0 12a1.5 1.5 0 0 1 1.5-1.5h21a1.5 1.5 0 0 1 0 3h-21A1.5 1.5 0 0 1 0 12Zm1.5 5a1.5 1.5 0 0 0 0 3h21a1.5 1.5 0 0 0 0-3h-21Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
